shadow$provide[526] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, ShaderGraph:{enumerable:true, get:function() {
  return ShaderGraph;
}}, inspect:{enumerable:true, get:function() {
  return inspect;
}}, load:{enumerable:true, get:function() {
  return load;
}}, visualize:{enumerable:true, get:function() {
  return visualize;
}}});
var require$_DOT__SLASH_block = require("./block");
var Factory = require("./factory");
var GLSL = require("./glsl");
var Graph = require("./graph");
var Linker = require("./linker");
var Visualize = require("./visualize");
const {library, cache} = Factory;
const {visualize, inspect} = Visualize;
const {Snippet} = Linker;
const merge = function(a, b = {}) {
  const out = {};
  for (let key in a) {
    out[key] = b[key] || a[key];
  }
  return out;
};
class ShaderGraph {
  constructor(snippets, config) {
    const defaults = {globalUniforms:false, globalVaryings:true, globalAttributes:true, globals:[], autoInspect:false,};
    this.config = merge(defaults, config);
    this.fetch = cache(library(GLSL, snippets, Snippet.load));
  }
  shader(config) {
    if (config == null) {
      config = {};
    }
    const _config = merge(this.config, config);
    return new Factory.Factory(GLSL, this.fetch, _config);
  }
  material(config) {
    return new Factory.Material(this.shader(config), this.shader(config));
  }
  inspect(shader) {
    return ShaderGraph.inspect(shader);
  }
  visualize(shader) {
    return ShaderGraph.visualize(shader);
  }
  static inspect(shader) {
    return inspect(shader);
  }
  static visualize(shader) {
    return visualize(shader);
  }
}
ShaderGraph.Block = require$_DOT__SLASH_block.Block;
ShaderGraph.Factory = Factory;
ShaderGraph.GLSL = GLSL;
ShaderGraph.Graph = Graph;
ShaderGraph.Linker = Linker;
ShaderGraph.Visualize = Visualize;
function load(snippets, config = {}) {
  return new ShaderGraph(snippets, config);
}

};